import { ref } from 'vue'

const isOpen = ref(false)
const applicationId = ref<string | number | null>(null)

export function useOfferNegotiationModal() {
  const showModal = (appId: string | number) => {
    applicationId.value = appId
    isOpen.value = true
  }

  const hideModal = () => {
    isOpen.value = false
    applicationId.value = null
  }

  return {
    isOpen,
    applicationId,
    showModal,
    hideModal,
  }
}
